var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisualCommunication = function SvgVisualCommunication(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 217,
    viewBox: "0 0 218 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318771"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Right-2",
    d: "M186.652 173.223L171.899 164.707C171.526 164.494 171.526 163.801 171.899 163.161L183.267 143.477C183.64 142.837 184.24 142.491 184.613 142.704L199.366 151.22C199.912 151.54 199.619 152.793 198.86 153.379L190.437 159.829C190.037 160.136 189.717 160.682 189.664 161.176L188.291 171.704C188.171 172.65 187.225 173.543 186.679 173.223H186.652Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left-2",
    d: "M31.3781 173.223L46.1312 164.707C46.5044 164.494 46.5044 163.801 46.1312 163.148L34.7099 143.357C34.3368 142.718 33.737 142.371 33.3639 142.584L18.6108 151.1C18.0644 151.42 18.3576 152.673 19.1306 153.259L27.5799 159.763C27.9797 160.069 28.2996 160.616 28.3662 161.122L29.7656 171.691C29.8988 172.65 30.8317 173.53 31.3781 173.223Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-3",
    filter: "url(#filter0_d_1241_128273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.182 108.36C193.182 154.872 155.48 192.561 108.982 192.561C62.4835 192.561 24.7812 154.858 24.7812 108.36C24.7812 61.8622 62.4835 24.1599 108.982 24.1599C123.415 24.1599 137.009 27.7982 148.883 34.1952C175.257 48.4152 193.182 76.2954 193.182 108.36Z",
    fill: "url(#paint0_linear_1241_128273)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Front-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M188.504 108.36C188.504 152.273 152.908 187.883 108.982 187.883C65.0557 187.883 29.4591 152.286 29.4591 108.36C29.4591 64.4343 65.0557 28.8377 108.982 28.8377C122.615 28.8377 135.449 32.2628 146.657 38.3133C171.566 51.7469 188.491 78.0679 188.491 108.347L188.504 108.36Z",
    fill: "url(#paint1_linear_1241_128273)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Base-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_128273",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 28,
    width: 160,
    height: 160
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Front-4",
    d: "M188.504 108.36C188.504 152.273 152.908 187.883 108.982 187.883C65.0557 187.883 29.4591 152.286 29.4591 108.36C29.4591 64.4343 65.0557 28.8377 108.982 28.8377C122.615 28.8377 135.449 32.2628 146.657 38.3133C171.566 51.7469 188.491 78.0679 188.491 108.347L188.504 108.36Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_128273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M111.221 239.299C165.989 239.299 210.387 213.063 210.387 180.7C210.387 148.336 165.989 122.101 111.221 122.101C56.4524 122.101 12.054 148.336 12.054 180.7C12.054 213.063 56.4524 239.299 111.221 239.299Z",
    fill: "#00BC6C"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Stars-2",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M133.557 42.458C134.168 42.458 134.663 41.9627 134.663 41.3518C134.663 40.7409 134.168 40.2457 133.557 40.2457C132.946 40.2457 132.451 40.7409 132.451 41.3518C132.451 41.9627 132.946 42.458 133.557 42.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M135.996 53.5327C137.343 53.5327 138.435 52.4408 138.435 51.0939C138.435 49.7469 137.343 48.655 135.996 48.655C134.649 48.655 133.557 49.7469 133.557 51.0939C133.557 52.4408 134.649 53.5327 135.996 53.5327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M126.294 47.8554C127.589 47.8554 128.639 46.8053 128.639 45.5099C128.639 44.2144 127.589 43.1643 126.294 43.1643C124.998 43.1643 123.948 44.2144 123.948 45.5099C123.948 46.8053 124.998 47.8554 126.294 47.8554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51.5687 132.109C52.8641 132.109 53.9143 131.059 53.9143 129.764C53.9143 128.468 52.8641 127.418 51.5687 127.418C50.2733 127.418 49.2231 128.468 49.2231 129.764C49.2231 131.059 50.2733 132.109 51.5687 132.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.7291 142.184C52.0761 142.184 53.168 141.092 53.168 139.746C53.168 138.399 52.0761 137.307 50.7291 137.307C49.3822 137.307 48.2903 138.399 48.2903 139.746C48.2903 141.092 49.3822 142.184 50.7291 142.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M60.6312 136.174C61.2421 136.174 61.7373 135.679 61.7373 135.068C61.7373 134.457 61.2421 133.962 60.6312 133.962C60.0203 133.962 59.525 134.457 59.525 135.068C59.525 135.679 60.0203 136.174 60.6312 136.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M171.499 113.318L169.5 116.596C169.193 117.103 168.447 117.103 168.127 116.596L166.128 113.318C165.968 113.065 165.968 112.745 166.128 112.478L168.127 109.2C168.434 108.693 169.18 108.693 169.5 109.2L171.499 112.478C171.659 112.732 171.659 113.065 171.499 113.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M178.336 117.303L176.763 119.875C176.523 120.275 175.937 120.275 175.684 119.875L174.111 117.303C173.991 117.103 173.991 116.85 174.111 116.65L175.684 114.078C175.924 113.678 176.51 113.678 176.763 114.078L178.336 116.65C178.456 116.85 178.456 117.103 178.336 117.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M53.2347 61.7955L51.9153 63.9412C51.7287 64.2344 51.3022 64.2344 51.1157 63.9412L49.9562 62.0354C49.8629 61.8888 49.8629 61.7022 49.9562 61.5423L51.1157 59.6365C51.3022 59.3433 51.7287 59.3433 51.9153 59.6365L53.2347 61.7822V61.7955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M59.3916 74.6428L57.1261 78.3478C56.7662 78.9208 55.9266 78.9208 55.5801 78.3478L53.3145 74.6428C53.1413 74.3496 53.1413 73.9898 53.3145 73.6966L55.5801 69.9917C55.9399 69.4186 56.7795 69.4186 57.1261 69.9917L59.3916 73.6966C59.5649 73.9898 59.5649 74.3496 59.3916 74.6428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M175.764 103.483L174.191 106.055C173.951 106.455 173.365 106.455 173.112 106.055L171.539 103.483C171.419 103.283 171.419 103.029 171.539 102.83L173.112 100.257C173.352 99.8576 173.938 99.8576 174.191 100.257L175.764 102.83C175.884 103.029 175.884 103.283 175.764 103.483Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shine-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_128273",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 170,
    height: 169
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Back-4",
    d: "M193.222 108.2C193.222 154.712 155.52 192.401 109.022 192.401C62.5236 192.401 24.8213 154.699 24.8213 108.2C24.8213 61.7023 62.5236 24 109.022 24C123.455 24 137.049 27.6383 148.923 34.0353C175.297 48.2553 193.222 76.1355 193.222 108.2Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_128273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.15,
    d: "M7.06966 239.605C4.47088 232.355 3.16482 228.264 0.56604 219.122C17.9845 206.194 36.6957 197.452 55.2204 186.444C74.8112 174.809 90.7103 159.603 108.009 144.903C143.819 114.504 170.18 109.147 215.465 121.314C218.064 123.647 219.37 124.846 221.969 127.445C175.804 113.811 149.763 124.633 114.512 155.618C80.1953 185.804 39.3878 207.74 7.05634 239.592L7.06966 239.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.15,
    d: "M-2.93894 223.453C-18.7715 195.386 -25.8082 162.308 -33.1914 131.35C14.173 132.109 39.4678 108.36 74.2648 79.334C109.781 49.7079 137.462 41.8583 181.721 56.5447C192.196 66.9532 202.245 77.1884 211.973 88.3031C165.942 66.4467 135.942 96.366 104.517 128.498C70.5199 163.268 32.4178 190.602 -2.93894 223.453Z",
    fill: "white"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M143.605 80.067L143.579 98.2318L111.207 117.05L111.234 98.8848L143.605 80.067Z",
    fill: "#3C2ABC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M111.234 98.8848L111.207 117.05L65.2955 116.037L65.3222 97.8719L111.234 98.8848Z",
    fill: "#5B4AD8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M143.605 80.067L111.234 98.8848L65.3223 97.872C65.7088 91.395 70.1466 85.0114 78.6493 80.067C96.5342 69.6719 125.614 69.6719 143.619 80.067H143.605Z",
    fill: "#7B60F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M157.172 82.8923L157.146 117.196C157.132 123.966 152.681 130.71 143.805 135.881L143.832 101.577C152.708 96.4193 157.159 89.6625 157.172 82.8923Z",
    fill: "#CE8032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M143.832 101.564L143.805 135.867L111.207 117.05L111.234 82.7457L143.832 101.564Z",
    fill: "#E29142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M143.605 64.0745C161.61 74.4696 161.704 91.3151 143.832 101.71L111.234 82.8923L143.605 64.0745Z",
    fill: "#FDB35E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M65.2689 116.93L65.2956 107.441C65.2822 114.291 69.8001 121.154 78.8492 126.379C96.8541 136.774 125.947 136.774 143.832 126.379L143.805 135.867C125.92 146.263 96.8274 146.263 78.8225 135.867C69.7735 130.643 65.2423 123.78 65.2689 116.93Z",
    fill: "#DB457E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M143.832 126.379C125.947 136.774 96.8541 136.774 78.8492 126.379C69.4003 120.928 64.8824 113.691 65.3222 106.548L111.234 107.561L143.832 126.379Z",
    fill: "#F76497"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Banner-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M169.727 175.849C128.359 161.789 89.8707 161.669 48.3702 175.555C46.078 176.448 43.6258 175.769 42.8795 173.983C38.4949 166.906 36.2293 163.415 31.5515 156.498C30.7652 154.725 32.2578 152.326 34.9232 151.234C85.4328 133.109 132.771 133.202 183.227 151.553C185.879 152.66 187.372 155.058 186.572 156.831C181.907 163.748 179.642 167.239 175.244 174.303C174.484 176.089 172.032 176.755 169.74 175.849H169.727Z",
    fill: "#4539FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M48.7701 158.39L48.93 165.334L47.0642 166.04L42.573 160.749L44.1589 160.149L47.4374 164.201L47.2108 159.003L48.7834 158.404L48.7701 158.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M51.7286 157.417L53.821 163.628L52.315 164.134L50.2227 157.924L51.7286 157.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M56.4864 162.575C56.0732 162.535 55.7267 162.402 55.4202 162.175C55.1137 161.949 54.8871 161.629 54.7539 161.229L56.3798 160.736C56.4731 160.962 56.6063 161.109 56.7796 161.189C56.9528 161.269 57.1527 161.282 57.366 161.216C57.5925 161.149 57.7525 161.042 57.8591 160.896C57.9657 160.749 57.979 160.589 57.9257 160.403C57.8724 160.243 57.7924 160.136 57.6592 160.069C57.5259 160.003 57.366 159.949 57.206 159.936C57.0328 159.923 56.7929 159.909 56.4864 159.909C56.0466 159.909 55.6734 159.883 55.3802 159.83C55.087 159.776 54.8072 159.67 54.554 159.47C54.3008 159.27 54.1008 158.99 53.9942 158.603C53.821 158.017 53.8876 157.497 54.2074 157.044C54.5273 156.591 55.0337 156.258 55.7134 156.045C56.4064 155.831 57.0061 155.831 57.5392 156.045C58.059 156.245 58.4321 156.644 58.632 157.217L56.9795 157.724C56.8995 157.524 56.7796 157.391 56.6063 157.311C56.4331 157.231 56.2465 157.231 56.0333 157.297C55.8467 157.351 55.7134 157.444 55.6335 157.577C55.5535 157.711 55.5402 157.87 55.5935 158.057C55.6601 158.257 55.7934 158.39 56.0199 158.443C56.2465 158.497 56.5797 158.537 57.0195 158.537C57.4593 158.55 57.8324 158.577 58.1256 158.63C58.4188 158.683 58.6853 158.79 58.9519 158.977C59.2051 159.163 59.3917 159.443 59.5116 159.816C59.6183 160.176 59.6316 160.523 59.5383 160.869C59.445 161.216 59.2584 161.522 58.9652 161.802C58.672 162.082 58.2855 162.295 57.8191 162.428C57.366 162.562 56.9262 162.615 56.513 162.575H56.4864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M61.4441 154.512L62.4303 158.31C62.5236 158.683 62.6969 158.963 62.9368 159.11C63.1767 159.27 63.4832 159.296 63.843 159.203C64.2028 159.11 64.4561 158.937 64.5893 158.683C64.7226 158.43 64.7493 158.11 64.656 157.737L63.6698 153.939L65.2157 153.539L66.2019 157.324C66.3485 157.884 66.3485 158.404 66.2019 158.857C66.0686 159.31 65.8154 159.683 65.4556 159.989C65.0957 160.296 64.6693 160.509 64.1762 160.642C63.6831 160.776 63.2033 160.789 62.7635 160.696C62.3237 160.602 61.9372 160.389 61.6041 160.056C61.2709 159.723 61.031 159.27 60.8844 158.71L59.8982 154.925L61.4441 154.525V154.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M72.279 157.471L69.8934 157.99L69.7602 159.203L68.1343 159.563L69.0672 152.66L70.8663 152.273L74.5712 158.177L72.9187 158.537L72.2923 157.484L72.279 157.471ZM71.6126 156.351L70.3066 154.179L70.0267 156.698L71.5993 156.351H71.6126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M77.2233 156.431L79.2756 156.058L79.4889 157.271L75.8639 157.924L74.7045 151.473L76.2771 151.194L77.2233 156.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M82.9807 151.633C83.1939 151.1 83.5271 150.647 83.9935 150.314C84.46 149.967 84.9931 149.754 85.6328 149.674C86.4057 149.568 87.0854 149.688 87.6851 150.034C88.2848 150.367 88.7247 150.874 89.0045 151.553L87.272 151.78C87.1121 151.527 86.8988 151.34 86.6456 151.234C86.3924 151.127 86.1125 151.087 85.806 151.127C85.3129 151.194 84.9397 151.407 84.6865 151.793C84.4333 152.18 84.34 152.646 84.4067 153.206C84.4733 153.766 84.6865 154.205 85.033 154.512C85.3795 154.819 85.7927 154.925 86.2858 154.872C86.5923 154.832 86.8455 154.725 87.0721 154.552C87.2986 154.379 87.4452 154.152 87.5385 153.859L89.271 153.632C89.1777 154.365 88.8845 154.965 88.3914 155.432C87.8983 155.898 87.2587 156.191 86.4857 156.298C85.8593 156.378 85.2729 156.311 84.7398 156.098C84.2068 155.885 83.767 155.538 83.4205 155.072C83.074 154.605 82.8607 154.059 82.7808 153.419C82.7008 152.78 82.7674 152.193 82.9807 151.647V151.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M92.4695 155.192C91.9364 154.952 91.4966 154.592 91.1501 154.099C90.8036 153.619 90.6037 153.046 90.5504 152.42C90.4971 151.78 90.5904 151.194 90.8569 150.66C91.1101 150.127 91.4833 149.701 91.9764 149.368C92.4695 149.035 93.0159 148.848 93.6289 148.795C94.242 148.741 94.815 148.835 95.3481 149.075C95.8812 149.314 96.321 149.674 96.6542 150.154C96.9874 150.634 97.1873 151.194 97.2406 151.833C97.2939 152.473 97.2006 153.059 96.9474 153.592C96.6942 154.126 96.321 154.565 95.8412 154.885C95.3614 155.218 94.8017 155.405 94.1887 155.458C93.5756 155.512 93.0025 155.418 92.4695 155.178V155.192ZM95.2681 153.393C95.548 153.019 95.668 152.553 95.6147 151.98C95.5614 151.407 95.3748 150.954 95.0283 150.634C94.6818 150.314 94.2553 150.181 93.7355 150.221C93.2025 150.261 92.8026 150.474 92.5228 150.834C92.2429 151.207 92.123 151.673 92.1763 152.26C92.2296 152.833 92.4161 153.286 92.7627 153.606C93.1092 153.926 93.5356 154.059 94.0687 154.019C94.5885 153.979 94.9883 153.766 95.2815 153.393H95.2681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M106.196 148.195L106.45 154.739L104.85 154.805L104.704 150.887L103.384 154.872L102.105 154.925L100.479 151.047L100.626 154.978L99.0264 155.032L98.7732 148.488L100.652 148.422L102.665 152.886L104.317 148.288L106.196 148.222V148.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M115.672 148.275L115.579 154.819L113.979 154.792L114.033 150.86L112.513 154.765H111.221L109.808 150.794L109.755 154.725L108.156 154.699L108.249 148.155L110.128 148.182L111.9 152.74L113.78 148.235L115.659 148.262L115.672 148.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M119.297 148.475L119.057 152.38C119.03 152.766 119.11 153.073 119.297 153.299C119.47 153.526 119.75 153.646 120.123 153.672C120.496 153.699 120.789 153.606 121.003 153.406C121.216 153.206 121.336 152.913 121.363 152.526L121.602 148.621L123.188 148.715L122.948 152.62C122.908 153.206 122.762 153.686 122.482 154.072C122.202 154.459 121.856 154.739 121.429 154.925C121.003 155.098 120.523 155.178 120.003 155.152C119.483 155.125 119.03 154.992 118.644 154.765C118.257 154.539 117.951 154.219 117.738 153.792C117.524 153.366 117.444 152.873 117.471 152.286L117.711 148.382L119.31 148.475H119.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M130.305 155.991L128.719 155.831L126.48 151.54L126.067 155.551L124.481 155.392L125.161 148.875L126.747 149.035L128.986 153.353L129.412 149.314L130.998 149.474L130.318 155.991H130.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M134.556 149.968L133.663 156.458L132.078 156.245L132.97 149.754L134.556 149.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M136.409 151.767C136.769 151.314 137.222 150.994 137.768 150.794C138.315 150.594 138.888 150.554 139.514 150.66C140.287 150.794 140.9 151.1 141.38 151.607C141.86 152.1 142.126 152.713 142.193 153.446L140.46 153.153C140.38 152.859 140.234 152.62 140.021 152.446C139.807 152.26 139.554 152.153 139.248 152.1C138.768 152.02 138.341 152.113 137.981 152.406C137.622 152.686 137.395 153.113 137.302 153.686C137.209 154.259 137.275 154.725 137.528 155.112C137.768 155.498 138.141 155.738 138.621 155.818C138.928 155.871 139.208 155.845 139.461 155.738C139.714 155.631 139.941 155.458 140.114 155.218L141.846 155.512C141.54 156.178 141.087 156.671 140.474 156.978C139.861 157.284 139.168 157.377 138.408 157.244C137.782 157.137 137.248 156.898 136.795 156.538C136.356 156.178 136.036 155.725 135.836 155.178C135.649 154.632 135.609 154.046 135.716 153.406C135.822 152.766 136.062 152.22 136.422 151.767H136.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M147.244 157.75L144.858 157.231L144.232 158.284L142.606 157.924L146.311 152.02L148.11 152.406L149.043 159.31L147.39 158.95L147.257 157.737L147.244 157.75ZM147.097 156.458L146.817 153.939L145.525 156.111L147.097 156.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M156.519 154.499L156.2 155.738L154.52 155.298L153.201 160.403L151.655 160.003L152.974 154.899L151.295 154.459L151.615 153.219L156.519 154.485V154.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M159.611 155.392L157.786 161.682L156.253 161.242L158.079 154.952L159.611 155.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M160.931 162.255C160.531 161.829 160.264 161.322 160.144 160.736C160.011 160.149 160.051 159.563 160.251 158.95C160.451 158.337 160.771 157.844 161.21 157.444C161.65 157.057 162.17 156.804 162.743 156.684C163.316 156.564 163.903 156.604 164.489 156.804C165.075 156.991 165.568 157.311 165.968 157.737C166.368 158.164 166.635 158.67 166.755 159.243C166.875 159.816 166.835 160.416 166.648 161.016C166.461 161.615 166.128 162.122 165.688 162.522C165.249 162.921 164.742 163.175 164.169 163.281C163.596 163.388 163.01 163.361 162.437 163.161C161.85 162.975 161.357 162.655 160.957 162.228L160.931 162.255ZM164.209 161.695C164.609 161.455 164.902 161.069 165.089 160.522C165.262 159.976 165.262 159.483 165.075 159.057C164.889 158.63 164.542 158.337 164.049 158.177C163.543 158.017 163.09 158.044 162.69 158.27C162.29 158.497 161.997 158.883 161.81 159.443C161.637 159.989 161.637 160.483 161.824 160.909C162.01 161.335 162.357 161.629 162.863 161.789C163.356 161.948 163.809 161.909 164.222 161.682L164.209 161.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M172.499 166.733L171.006 166.173L169.94 161.455L168.514 165.24L167.021 164.681L169.327 158.55L170.819 159.11L171.886 163.854L173.325 160.056L174.817 160.616L172.512 166.746L172.499 166.733Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_128273",
    x: 0.792522,
    y: 0.171185,
    width: 216.378,
    height: 216.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9944
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_128273",
    x1: 108.982,
    y1: 227.198,
    x2: 108.982,
    y2: -13.0493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#13D5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2AD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#38D394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3ED38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#40D380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D37C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_128273",
    x1: 108.982,
    y1: -13.0493,
    x2: 108.982,
    y2: 162.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#08D5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1DD4BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2DD3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#38D38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3FD380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D37C"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisualCommunication);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "visual-communication.fd1a27b.svg";